export const GET_ASPIRATION = "GET_ASPIRATION";
export const ASPIRATION_ERROR = "ASPIRATION_ERROR";
export const GET_ASPIRATION_BY_ID = "GET_ASPIRATION_BY_ID";
export const POST_ASPIRATION_CREATE = "POST_ASPIRATION_CREATE";
export const GET_ASPIRATION_BY_CATEGORY = "GET_ASPIRATION_BY_CATEGORY";
